import { render, staticRenderFns } from "./EntranceSelectionLProblem.vue?vue&type=template&id=004537a0&scoped=true&lang=pug&"
import script from "./EntranceSelectionLProblem.vue?vue&type=script&lang=ts&"
export * from "./EntranceSelectionLProblem.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceSelectionLProblem.vue?vue&type=style&index=0&id=004537a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004537a0",
  null
  
)

export default component.exports